import SuccessModal from 'components/Modals/ErrorModal'
import {
    DEFAULT_ERROR_STATE,
    IError,
    useAppContext,
} from 'context/AppContext'
import GenericError from 'components/GenericError/GenericError'
import Translation from 'components/Translation'
import { useState, SetStateAction } from 'react'
import { getCurrencySymbol } from 'utils/string-localization-helper'

export const PAYMENT_POLICY_OPTIONS = [
    {
        id: 1,
        title: 'Require a payment, valid coupon, or membership at booking time',
        value: 'allOptions',
        translationKey: 'all_options',
    },
    {
        id: 2,
        title: 'Payment at booking time is optional',
        value: 'optionalPayment',
        translationKey: 'optional_payment',
    },
    {
        id: 2,
        title: 'Do not allow payment at booking time',
        value: 'notAllowed',
        translationKey: 'payment_not_allowed',
    },
    {
        id: 3,
        title: 'Only allow payment in-person',
        value: 'inPerson',
        translationKey: 'payment_in_person',
    },
]

export const PAYMENT_POLICY_KEY = 'PAYMENT_POLICY'
export const DEFAULT_COMMISSION = 'DEFAULT_COMMISSION'

export interface IPaymentPolicy {
    selectedPolicy: string
    setSelectedPolicy: React.Dispatch<SetStateAction<string>>
    defaultCommission: string
    setDefaultCommission: React.Dispatch<SetStateAction<string>>
    commissionType: 'PERCENT' | 'EXACT'
    setCommissionType: React.Dispatch<SetStateAction<'PERCENT' | 'EXACT'>>
    is_dirty: boolean
    setIsDirty: React.Dispatch<SetStateAction<boolean>>
}
function PaymentPolicy(props: IPaymentPolicy) {
    const {
        commissionType,
        setSelectedPolicy,
        setDefaultCommission,
        setCommissionType,
        selectedPolicy,
        defaultCommission,
        is_dirty,
        setIsDirty,
    } = props

    const [error, setError] = useState<IError>(DEFAULT_ERROR_STATE)
    const [success, setSuccess] = useState('')
    const { translations } = useAppContext()

    return (
        <div className=" mt-10 h-loose flex flex-col">
            {!!error?.message?.length && (
                <GenericError
                    error_message={error.message}
                    onCloseModal={() => setError(DEFAULT_ERROR_STATE)}
                    tag={error?.tag}
                />
            )}
            {success?.length > 0 && (
                <SuccessModal
                    type="success"
                    error_message={translations[success]}
                    onCloseModal={() => setSuccess('')}
                />
            )}
            <div className="flex flex-col w-1/2">
                <label className="text-lg">
                    <Translation
                        content_key={'payment_policy' || 'Payment Policy'}
                    />
                </label>
                <select
                    className="text-black px-7 py-3 rounded-md mt-2 border-2 border-gray-200"
                    onChange={(e) => {
                        setSelectedPolicy(e.target.value)
                        setIsDirty(true)
                    }}
                    value={selectedPolicy}
                >
                    {PAYMENT_POLICY_OPTIONS.map((item) => (
                        <option key={item.id} value={item.value}>
                            {translations[item?.translationKey] ||
                                item.title}
                        </option>
                    ))}
                </select>
            </div>
            <div className="flex flex-col w-1/2 mt-10">
                <div>
                    <label className="text-lg">
                        <Translation
                            content_key={
                                'default_commission_rate' ||
                                'Default Commission Rate'
                            }
                        />
                    </label>
                </div>
                <div className="border-2 border-gray-200 rounded-md w-60 flex items-center">
                    <select
                        className="h-full border-transparent bg-gray-200 rounded-l-md"
                        defaultValue={commissionType}
                        onChange={(e) => {
                            setCommissionType(
                                e.target.value as 'PERCENT' | 'EXACT'
                            )
                            setIsDirty(true)
                        }}
                    >
                        <option
                            value={'PERCENT'}
                            selected={commissionType === 'PERCENT'}
                        >
                            {'%'}
                        </option>
                        <option
                            value={'EXACT'}
                            selected={commissionType === 'EXACT'}
                        >
                            {getCurrencySymbol()}
                        </option>
                    </select>
                    <input
                        className="text-black h-full w-full rounded-md px-5"
                        value={defaultCommission + ''}
                        onChange={(e) => {
                            setDefaultCommission(e.target.value)
                            setIsDirty(true)
                        }}
                    />
                </div>
            </div>
        </div>
    )
}

export default PaymentPolicy
